export default {
  body: {
    cmpt: {
      type: 'CGoodsList'
    }
  }
}
